module.exports = __webpack_public_path__ + "static/img/head3.d03c963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/head3.png
// module id = aEvR
// module chunks = 2